import { useIsAuthenticated, useMsal } from "@azure/msal-react";

const GUEST_ROLE = process.env.REACT_APP_AZURE_GUEST_ROLE;
const ADMIN_ROLE = process.env.REACT_APP_AZURE_ADMIN_ROLE;

const useAuth = () => {
  const isAuthenticated = useIsAuthenticated();
  const { accounts, inProgress } = useMsal();

  const account = accounts?.[0];
  const roles = account?.idTokenClaims?.roles;  
  const rolesReady = Array.isArray(roles);

  const isGuest = rolesReady && GUEST_ROLE ? roles.includes(GUEST_ROLE) : false;
  const isAdmin = rolesReady && ADMIN_ROLE ? roles.includes(ADMIN_ROLE) : false;

  // Loading while MSAL is processing or while authenticated but groups not yet hydrated
  const isLoading = inProgress !== "none" || (isAuthenticated && !rolesReady);

  const isAuthorized = rolesReady ? (isGuest || isAdmin) : null;

  return {
    isAuthenticated,
    isAuthorized,
    isGuest,
    isAdmin,
    isLoading,
  };
};

export default useAuth;